export default __webpack_public_path__ + "static/media/mackbookReview.d7b71fb1.md";